import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { bankDataByBIC, isValidBIC } from 'bankdata-germany';
import { IBAN } from 'ibankit';
import { ibanToBic } from 'iban-to-bic';
import { HelperService } from '../../../core/services/helper.service';
import { I18nService } from '../../../core/services/i18n.service';
import { CustomerGroup } from '../../enums/organisation/customer-group';
import { PaymentData } from '../../interfaces/payment/payment-data';
import { PaymentInvalidFlags } from '../../interfaces/payment/payment-invalid-flags';
import { BaseComponent } from './base.component';

@Component({
  template: '',
})
export abstract class BaseAddPaymentComponent extends BaseComponent {

  @Input() paymentData: PaymentData;
  @Input() paymentInvalidFlags: PaymentInvalidFlags;
  @Input() customerGroup: CustomerGroup;
  @Output() ibanValidated = new EventEmitter<boolean>()

  public i18n = inject(I18nService);
  public helper = inject(HelperService);

  /** Options and Models */
  stateOptions = [
    {value: 'TEST', label: 'Test'},
    {value: 'LIVE', label: 'Live'},
  ];

  /**
   * show invalid IBAN help
   */
  showInvalidIBAN: boolean = false;

  /**
   * validate IBAN and fetch BIC
   * in TEST-Mode only check the IBAN when IBAN-Data was entered
   */
  checkIBAN() {
    this.paymentData.IBAN = this.paymentData.IBAN.toUpperCase();
    if (this.paymentData.status === 'TEST') {
      if (this.paymentData.IBAN.trim() === '') {
        this.showInvalidIBAN = false;
      } else {
        this.showInvalidIBAN = !IBAN.isValid(this.paymentData.IBAN);
      }
    } else {
      this.showInvalidIBAN = !IBAN.isValid(this.paymentData.IBAN);
    }
    if (!this.showInvalidIBAN && this.paymentData.IBAN.trim() !== '') {
      this.paymentData.BIC = ibanToBic(this.paymentData.IBAN);
      if (isValidBIC(this.paymentData.BIC)) {
        this.paymentData.bank = bankDataByBIC(this.paymentData.BIC).bankName;
      }
    }
    this.ibanValidated.emit(!this.showInvalidIBAN);
  }

}
